export * as icons from '@wix/auto_sdk_media-manager_icons/meta';
